import React from "react";
import { createRoot } from "react-dom/client";
import FeaturedSlider from "../components/FeaturedSlider/FeaturedSlider";

const renderFeaturedSlider = ($) => {
	const sliders = $(".js-featured-slider").toArray();

	if (sliders.length > 0) {

		// Loop through each slider and render the component
		sliders.forEach((slider) => {
			let props = {...slider.dataset};
	
			const root = createRoot(slider);
			root.render(<FeaturedSlider {...props} />);
		});

	}
};

export default renderFeaturedSlider;
